import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

import { IconComponent } from '@shared/components/icon/icon.component';

import { ComparisonCard } from '../../constants/patient-curves.constants';
import { AgPatientDriverComparisonCardComponent } from '../ag-patient-driver-comparison-card/ag-patient-driver-comparison-card.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, AgPatientDriverComparisonCardComponent, IconComponent],
  selector: 'aux-ag-patient-driver-comparison-panel',
  styles: [],
  templateUrl: './ag-patient-driver-comparison-panel.component.html',
})
export class AgPatientDriverComparisonPanelComponent {
  @Input() comparisonCards$: Observable<ComparisonCard[]> | undefined;
}
